import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';

// Redux
import { savePosition, GetPosition, GetPositionIdPIES } from './index';

// Api's
import { positionApi } from '../../api';
import { PositionResponse } from '@/main/models/response';
import {
  errorBoundaryReduxSaga,
  renderErrorReduxSaga
} from '@/main/services/utils';

export function* getPositionSaga(action: GetPosition) {
  try {
    const response: AxiosResponse<Result<PositionResponse[]>> = yield call(
      positionApi.getPosition,
      action.payload.request
    );

    if (response.data.result) {
      yield put(
        savePosition(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        savePosition(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

export function* getPositionWithIdPIESSaga(action: GetPositionIdPIES) {
  try {
    const response: AxiosResponse<Result<PositionResponse[]>> = yield call(
      positionApi.getPositionWithIdPIES,
      action.payload.request
    );

    if (response.data.result) {
      yield put(
        savePosition(
          response.data.result,
          false,
          null,
          action.payload.keyReducer
        )
      );
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(
        savePosition(
          null,
          true,
          resultError.messagesDataError,
          action.payload.keyReducer
        )
      );
    }
  }
}

